import { render, staticRenderFns } from "./visa_table.vue?vue&type=template&id=c3c51b3c&scoped=true"
import script from "./visa_table.vue?vue&type=script&lang=js"
export * from "./visa_table.vue?vue&type=script&lang=js"
import style0 from "./visa_table.vue?vue&type=style&index=0&id=c3c51b3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c51b3c",
  null
  
)

export default component.exports